import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportOsXFinancialCsv } from './OsXFinancial.service';

export function useOsXFinancialReportCsv() {
  return useMutation(getQuestReportOsXFinancialCsv, {
    onSuccess() {
      notification.success({
        message: 'O relatório OS x Financeiro foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
